import React from 'react';
import { useTranslation } from 'react-i18next';

const BankConnected = () => {
  const { t } = useTranslation();
  return (
    <div className="text-left" data-testid="bank-connected-screen">
      <div>
        <h1 className="uppercase text-md sm:text-lg font-semi-bold">{t('Account confirmed')}</h1>
      </div>
      <div className="mt-2 mb-6 text-base sm:text-md font-normal" data-testid="bank-connected-screen-content">
        {t(`Thank you, we now have access to the following account.`)}
      </div>
    </div>
  );
};

export default BankConnected;
